// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {connect} from 'react-redux';
import {bindActionCreators, Dispatch} from 'redux';

import isEqual from 'lodash/isEqual';

import {getEmojiMap} from 'selectors/emojis';
import {getCurrentLocale} from 'selectors/i18n';
import {GlobalState} from 'types/store';
import {GenericAction} from 'mattermost-redux/types/actions';

import {addReaction} from 'actions/post_actions';
import {Emoji} from 'mattermost-redux/types/emojis';

import EmojiMap from 'utils/emoji_map';

import PostReaction from './post_recent_reactions';

function mapDispatchToProps(dispatch: Dispatch<GenericAction>) {
    return {
        actions: bindActionCreators({
            addReaction,
        }, dispatch),
    };
}

function makeGetDefaultEmojis() {
    let prevDefaultEmojis: Emoji[] = [];

    return (emojiMap: EmojiMap) => {
        const newDefaultEmojis = [emojiMap.get('thumbsup'), emojiMap.get('grinning'), emojiMap.get('white_check_mark')];
        if (!isEqual(prevDefaultEmojis, newDefaultEmojis)) {
            prevDefaultEmojis = newDefaultEmojis;
        }
        return prevDefaultEmojis;
    };
}

const getDefaultEmojis = makeGetDefaultEmojis();

function mapStateToProps(state: GlobalState) {
    const locale = getCurrentLocale(state);
    const emojiMap = getEmojiMap(state);
    const defaultEmojis = getDefaultEmojis(emojiMap);

    return {
        defaultEmojis,
        locale,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PostReaction);
